import _extends from "/app/node_modules/babel-runtime/helpers/extends";
import _regeneratorRuntime from "/app/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/app/node_modules/babel-runtime/helpers/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from "vuex";
import posJson from "~~/jsons/pos";

export default {
  fetch: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var store = _ref.store,
          app = _ref.app,
          query = _ref.query,
          redirect = _ref.redirect;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(["process", "worked"].indexOf(query.type) === -1 || !query.id || !query.idA)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", redirect("/dashboard"));

            case 2:
              _context.next = 4;
              return store.dispatch("dashboard/details/affiliationDetail", {
                idAffiliationPoW: query.idA,
                idAffiliation: query.id,
                type: query.type
              });

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function fetch(_x) {
      return _ref2.apply(this, arguments);
    }

    return fetch;
  }(),
  data: function data() {
    return {
      dataClient: false,
      openCommerce: false,
      openAttention: false,
      openAssociated: false,
      openImages: false,
      concreted: true
    };
  },

  methods: {
    openSlide: function openSlide() {
      this.dataClient = !this.dataClient;
    },
    openSlideCommerce: function openSlideCommerce() {
      this.openCommerce = !this.openCommerce;
    },
    openSlideAttention: function openSlideAttention() {
      this.openAttention = !this.openAttention;
    },
    openAssociatedBank: function openAssociatedBank() {
      this.openAssociated = !this.openAssociated;
    },
    openAssociatedImages: function openAssociatedImages() {
      this.openImages = !this.openImages;
    },
    download: function download() {
      //   console.log("download xa");
      this.$store.dispatch("dashboard/details/downloadAfiliationRequest");
    }
  },
  computed: _extends({}, mapState({
    data: function data(state) {
      return state.dashboard.details.affiliationProcess.seller || [];
    },
    affiliation: function affiliation(state) {
      return state.dashboard.details.affiliation || [];
    }
  }), {
    connectionType: function connectionType() {
      var idProduct = this.affiliation.dateProduct ? this.affiliation.dateProduct.id : 0;
      return posJson[idProduct] ? posJson[idProduct].TipoConexion : "";
    },
    installationTariff: function installationTariff() {
      var idProduct = this.affiliation.dateProduct ? this.affiliation.dateProduct.id : 0;
      return posJson[idProduct] ? posJson[idProduct].tarifas.installation : "";
    }
  })
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/affiliation-detail.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/affiliation-detail.vue
// module chunks = 23